import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {NgxFiltersService} from './ngx-filters.service';
import {Filter, FilterTypes} from "./ngx-types";

@Component({
  selector: 'ngx-filters',
  templateUrl: './ngx-filters.component.html',
  styleUrls: ['./ngx-filters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NgxFiltersComponent implements OnInit {

  @Input() filters: Filter[] = [];
  loading = true;
  @Input() filterCount = 0;
  @Output() filterCountChange = new EventEmitter<number>();
  @Output() clear = new EventEmitter();

  constructor(
    injector: Injector,
    public filtersService: NgxFiltersService,
    private el: ElementRef<HTMLElement>,
  ) {
    this.filtersService.conditionSource = this.filtersService.getConditionSource();
  }

  ngOnInit(): void {
  }

  get filterTypes() {
    return FilterTypes;
  }

  onClear(filter: Filter): void {
    this.filtersService.clearFilter(filter);
    this.filterCount -= 1;
    this.filterCountChange.emit(this.filterCount);
    this.clear.emit();
  }


  ngAfterViewInit(): void {

    this._setClassToDialogContainer(this.el, 'ngx-mat-cdk-no-border-radius', 'mat-dialog-container');
    this._setClassToDialogContainer(this.el, 'ngx-mat-cdk-filters-max-height', 'mat-dialog-content');

    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  private _setClassToDialogContainer(el, className: string, targetSelect: string): void {
    if (el?.nativeElement?.parentElement) {
      const cls = el.nativeElement.parentElement.closest(targetSelect)?.classList;
      if (cls && !cls.contains(className)) {
        cls.add(className);
      }
    }
  }
}
